import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import { useRequestEnterpriseInfo } from '@features/payments/hooks/useRequestEnterpriseInfo';
import CloseIcon from '@mui/icons-material/Close';
import { InfoIcon } from '../../../../vectors/index';

type EnterpriseInfoModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const EnterpriseInfoModal: FC<EnterpriseInfoModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const [errorText, setErrorText] = useState('');

  const { requestEnterpriseInfo, isRequestEnterpriseInfoLoading } =
    useRequestEnterpriseInfo({ setErrorText });

  const handleRequest = () =>
    requestEnterpriseInfo(undefined, {
      onSuccess: () => {
        handleClose();
        toast.success('Request sent!');
      },
    });

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <InfoIcon />
        <br />
        <Typography variant="h4">
          Enterprise Info
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <Typography variant="subtitle1" textAlign="center">
            Request more info about StaffedUp Enterprise?
          </Typography>
          <Typography color="text.secondary" textAlign="center">
            We will be in touch with you shortly to see if StaffedUp Enterprise
            is right for you!
          </Typography>
          <LoadingButton
            onClick={handleRequest}
            loading={isRequestEnterpriseInfoLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SendOutlinedIcon />}
          >
            Send Request
          </LoadingButton>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Go back
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EnterpriseInfoModal;
